(window.MyModule = function ($, Behaviors) {
    "use strict";
    var module = {};
    function MemberSlider(elem) {
        Behaviors.init(MemberSlider, this, arguments);

        this.membersSlider = this.$elem.find(MemberSlider.ELEMENTS.membersSlider).slick({
            dots: false,
            arrows: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            fade: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: $('.MemberSlider_arrows-left'),
            nextArrow: $('.MemberSlider_arrows-right'),
            autoplaySpeed: 6000,
            adaptiveHeight: true,
            // autoplay: false,
            autoplay: true,
        });

    }
    Behaviors.inherit(MemberSlider, Behaviors.Behavior);
    MemberSlider.QUERY = "[data-MemberSlider-slider]";
    MemberSlider.ELEMENTS = {
        membersSlider: ".MemberSlider_slider",
        membersNavigation: ".MemberSlider_navigation"
    };
    Behaviors.register_behavior(MemberSlider);
    module.MemberSlider = MemberSlider;
    return module;
}(window.jQuery, window.Behaviors));